import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/joy';
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import evidenceActions from 'actions/evidenceActions';
import observationActions from 'actions/observationActions';

import Sheet from 'components/core/Sheet';
import Button from 'components/core/Button';
import Typography from 'components/core/Typography';
import Stack from 'components/core/Stack';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import EvidenceDossier from 'components/EvidenceDossier';
import ObservationsTable from 'components/ObservationsTable';

const EvidenceView = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { evidenceId } = useParams();
    const evidence = useSelector(({ evidence }) => evidence.current);
    const observations = useSelector(({ observation }) => observation.list);
    const pagination = useSelector(({ observation }) => observation.pagination);
    const isLoading = useSelector(({ observation }) => observation.isLoading);
    const [pageSize] = useState(20);

    useEffect(() => {
        dispatch(evidenceActions.get(evidenceId));
        dispatch(observationActions.listObservationsForEvidence(evidenceId, 1, pageSize));
    }, [evidenceId, dispatch, pageSize]);

    useEffect(() => {
        return () => {
            dispatch(observationActions.clearList());
        };
    }, [dispatch]);

    const loadMoreObservations = () => {
        if (!pagination.hasMore) return;
        
        dispatch(observationActions.listObservationsForEvidence(
            evidenceId, 
            pagination.page + 1, 
            pagination.pageSize,
            true
        ));
    };

    if (!evidence) {
        return null;
    }

    return (
        <Stack
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
                mx: { xs: 1, sm: 1, md: 5, lg: 10, xl: 30 }
            }}
        >
            <Sheet sx={{width: '100%', background: 'none'}}>
                <Button
                    variant="text" 
                    onClick={() => navigate(-1)}
                    sx={{ padding: 0}}
                >
                    <Stack
                        direction="row"
                        spacing={2}
                    >
                        <ArrowBackIosIcon
                            sx={{ color: 'black', fontSize: 18, mt: 2}}
                        />
                        <Typography sx={{ fontSize: 18 }}>Back</Typography>
                    </Stack>
                </Button>
            </Sheet>
            <EvidenceDossier evidence={evidence} />
            <ObservationsTable
                observations={observations || []}
                onLoadMore={loadMoreObservations}
                hasMoreRecords={pagination.hasMore}
                isLoading={isLoading}
                totalCount={pagination.total}
            />
        </Stack>
    );
};

export default EvidenceView;